import { divider } from 'assets/colors';
import { IDocumentType } from '../types/document';
import type { SetValueConfig } from 'react-hook-form';

export enum ATTACHMENT_STATUS {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ARCHIVED = 'Archived',
}

export enum EQUIPMENT_STATUS {
  ACTIVE = '1',
  INACTIVE = '2',
  ARCHIVED = '3',
  MAINTENANCE = '4',
}

export const EQUIPMENT_STATUS_OPTION_LABELS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ARCHIVED: 'Archived',
  MAINTENANCE: 'On Maintenance',
} as const;

export const EQUIPMENT_STATUS_LABELS = {
  [EQUIPMENT_STATUS.ACTIVE]: EQUIPMENT_STATUS_OPTION_LABELS.ACTIVE,
  [EQUIPMENT_STATUS.INACTIVE]: EQUIPMENT_STATUS_OPTION_LABELS.INACTIVE,
  [EQUIPMENT_STATUS.ARCHIVED]: EQUIPMENT_STATUS_OPTION_LABELS.ARCHIVED,
  [EQUIPMENT_STATUS.MAINTENANCE]: EQUIPMENT_STATUS_OPTION_LABELS.MAINTENANCE,
} as const;

export const REGISTRY_STATUS = {
  EQUIPMENT: 'EQUIPMENT',
  ATTACHMENT: 'ATTACHMENT',
} as const;

export const EQUIPMENT_TYPE_LIST_TYPES = {
  EQUIPMENT: 'Equipment',
  ATTACHMENT: 'Attachment',
} as const;

export enum LIST_VIEW {
  LIST = 'LIST',
  MAP = 'MAP',
}

export enum DOCUMENT_REMINDER_TYPE {
  HOUR = 'Hour',
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
}

export enum FORM_TYPE {
  PRESTART = 'Prestart',
  INSPECTION = 'Inspection',
  MAINTENANCE = 'Maintenance',
  DEFECT_REPORT = 'Defect Report',
  OTHERS = 'Other',
}

export const MAINTENANCE_TYPE = {
  Servicing: 'Servicing',
  Maintenance: 'Maintenance',
} as const;

export const FORM_AND_SUBMISSION_TABLE_TABS = {
  FORMS: { value: 0, label: 'FORMS' },
  SUBMISSIONS: { value: 1, label: 'SUBMISSIONS' },
};

export const ATTACHMENT_STATUS_OPTIONS = [
  { value: ATTACHMENT_STATUS.ACTIVE, label: 'Active' },
  { value: ATTACHMENT_STATUS.INACTIVE, label: 'Inactive' },
  { value: ATTACHMENT_STATUS.ARCHIVED, label: 'Archived' },
];

export const documentTypeOptions: Array<{
  value: IDocumentType;
  label: IDocumentType;
}> = [
  { value: 'Warranty', label: 'Warranty' },
  { value: 'Insurance', label: 'Insurance' },
  { value: 'Manual', label: 'Manual' },
  { value: 'Certificate', label: 'Certificate' },
  { value: 'Compliance', label: 'Compliance' },
  { value: 'Other', label: 'Other' },
];

export const documentReminderTypeOptions = [
  { value: DOCUMENT_REMINDER_TYPE.DAY, label: DOCUMENT_REMINDER_TYPE.DAY },
  { value: DOCUMENT_REMINDER_TYPE.WEEK, label: DOCUMENT_REMINDER_TYPE.WEEK },
  { value: DOCUMENT_REMINDER_TYPE.MONTH, label: DOCUMENT_REMINDER_TYPE.MONTH },
];

export const DOCUMENT_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  EXPIRED: 'Expired',
  EXPIRES_SOON: 'Expires Soon',
  CANCELLED: 'Cancelled',
};

export const MAP_DOCUMENT_STATUS_LABEL: Record<string, string> = {
  [DOCUMENT_STATUS.ACTIVE]: 'Active',
  [DOCUMENT_STATUS.INACTIVE]: 'Inactive',
  [DOCUMENT_STATUS.EXPIRED]: 'Expired',
  [DOCUMENT_STATUS.EXPIRES_SOON]: 'Expiring Soon',
  [DOCUMENT_STATUS.CANCELLED]: 'Cancelled',
};

export const ALERT_STATUS = {
  EXPIRED: DOCUMENT_STATUS.EXPIRED,
  EXPIRING_SOON: DOCUMENT_STATUS.EXPIRES_SOON,
} as const;

export const ALERT_TYPES = {
  DOCUMENT: 'documents',
  MAINTENANCE: 'maintenance',
} as const;

export const DEFAULT_FILTERS = {
  type: [],
  status: null,
  supplier: [],
  plantManager: [],
};

export const DOCUMENT_TABLE_PROPERTIES = {
  enableRowSelection: false,
  enableHiding: false,
  enableRowActions: true,
  enablePagination: false,
  enableTableFooter: false,
  enableBottomToolbar: false,
  noDataHeight: '30vh',
  noDataIconDimensions: { height: 100, width: 100 },
  muiTableContainerProps: {
    sx: {
      maxHeight: 'calc(100vh - 270px)!important',
      minHeight: '250px !important',
      border: `1px solid ${divider}`,
    },
  },
  displayColumnDefOptions: {
    'mrt-row-actions': {
      size: 135,
      grow: 0,
      align: 'center',
      muiTableHeadCellProps: {
        align: 'center' as const,
      },
    },
  },
  muiTableProps: {
    sx: {
      tableLayout: 'fixed',
    },
  },
};

export const FORM_AND_SUBMISSION_TABLE_PROPERTIES = {
  enableRowSelection: false,
  enableSorting: false,
  enableHiding: false,
  enablePagination: false,
  enableTableFooter: false,
  enableBottomToolbar: false,
  noDataHeight: '30vh',
  noDataIconDimensions: { height: 100, width: 100 },
  muiTableContainerProps: {
    sx: {
      maxHeight: '332px !important',
      minHeight: '300px !important',
      border: `1px solid ${divider}`,
    },
  },
};

export const defaultSetValueOptions: SetValueConfig = {
  shouldDirty: true,
  shouldTouch: true,
  shouldValidate: true,
};
